import { render, staticRenderFns } from "./collectionModal.vue?vue&type=template&id=6bbf5372&"
import script from "./collectionModal.vue?vue&type=script&lang=js&"
export * from "./collectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports